/**
 * #582 — queue-replace epoch.
 * Bumped on every user-initiated queue replace (playAll/playFrom/playSingle).
 * ClientSyncHandler rejects stale rehydrated/server snapshots until the window expires.
 */

let queueReplaceGeneration = 0;
let queueReplaceRejectUntil = 0;

const REPLACE_REJECT_MS = 15_000;

export function bumpQueueReplaceGeneration(): number {
  queueReplaceGeneration += 1;
  queueReplaceRejectUntil = Date.now() + REPLACE_REJECT_MS;
  return queueReplaceGeneration;
}

export function getQueueReplaceGeneration(): number {
  return queueReplaceGeneration;
}

export function isQueueReplaceRejectActive(): boolean {
  return Date.now() < queueReplaceRejectUntil;
}

export function queueReplaceRejectUntilMs(): number {
  return queueReplaceRejectUntil;
}

/** @internal test reset */
export function resetQueueReplaceEpochForTests(): void {
  queueReplaceGeneration = 0;
  queueReplaceRejectUntil = 0;
}

export function trackIdsFromQueue(queue: { track?: { id?: string; qobuzTrackId?: string; serviceTrackId?: string; trackId?: string } }[]): Set<string> {
  const ids = new Set<string>();
  for (const item of queue) {
    const t = item?.track;
    if (!t) continue;
    const id = String(t.id || t.qobuzTrackId || t.serviceTrackId || t.trackId || '');
    if (id) ids.add(id);
  }
  return ids;
}

export function countQueueReplaceSurvivors(
  priorIds: Set<string>,
  intendedIds: Set<string>,
  resultQueue: { track?: { id?: string; qobuzTrackId?: string; serviceTrackId?: string; trackId?: string } }[],
): number {
  let survivors = 0;
  for (const item of resultQueue) {
    const t = item?.track;
    if (!t) continue;
    const id = String(t.id || t.qobuzTrackId || t.serviceTrackId || t.trackId || '');
    if (id && priorIds.has(id) && !intendedIds.has(id)) survivors += 1;
  }
  return survivors;
}
